import { useCart } from 'b2b-apps/shop/cart/hooks';
import { CartProductType } from 'b2b-common/core/cart/api/CartTypes';

type UseCartLicensedProductsReturnType = CartProductType[];

const useCartLicensedProducts = (): UseCartLicensedProductsReturnType => {
  const cartData = useCart();

  return cartData.data?.products
    ? cartData.data.products.filter(
      (product) => product.settings.requiresLicense,
    )
    : [];
};

export type { UseCartLicensedProductsReturnType };
export { useCartLicensedProducts };
